<template>
  <section
    class="border-b border-slate-200 bg-white pb-8 pt-8 md:pb-16 md:pt-28"
  >
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="mb-8 flex flex-wrap items-end justify-between gap-5">
        <div>
          <span
            class="inline-flex rounded-full bg-blue-50 px-3 py-1.5 text-xs font-black uppercase tracking-[0.14em] text-blue-700"
          >
            Produtos mais procurados
          </span>

          <h2 class="mt-3 text-2xl sm:text-3xl font-black tracking-tight text-[#071a3d]">
            Mais vendidos
          </h2>

          <p
            class="mt-2 max-w-2xl text-sm leading-6 text-slate-500 md:text-base"
          >
            Acesse rapidamente algumas das soluções mais procuradas na Casa do
            Software.
          </p>
        </div>

        <NuxtLink
          to="/produtos"
          class="inline-flex min-h-11 items-center justify-center rounded-xl border border-blue-700 px-5 py-2.5 text-sm font-bold text-blue-800 transition hover:bg-blue-50"
        >
          Ver todos os produtos →
        </NuxtLink>
      </div>

      <div
        v-if="pending"
        class="rounded-2xl border border-slate-200 bg-slate-50 py-14 text-center text-sm text-slate-500"
      >
        Carregando produtos...
      </div>

      <div
        v-else-if="displayProducts.length === 0"
        class="rounded-2xl border border-slate-200 bg-slate-50 p-8 text-center"
      >
        <h3 class="font-black text-[#071a3d]">Consulte nosso catálogo</h3>

        <p class="mt-2 text-sm text-slate-500">
          Veja as opções disponíveis de Windows, Office e Windows Server.
        </p>

        <NuxtLink
          to="/produtos"
          class="mt-5 inline-flex rounded-xl bg-[#062b62] px-5 py-3 text-sm font-bold text-white transition hover:bg-[#0a397e]"
        >
          Ver catálogo
        </NuxtLink>
      </div>

      <div
        v-else
        class="grid grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-3 xl:grid-cols-4"
      >
        <ProductCard
          v-for="product in displayProducts"
          :key="String(product.id)"
          :product="product"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import ProductCard from "~/components/ProductCard.vue";

const { data, pending } = await useFetch("/api/products/best-sellers", {
  server: true,
  lazy: false,
  timeout: 15000,
  default: () => [],
  transform: (raw: any) => {
    const products = Array.isArray(raw)
      ? raw
      : Array.isArray(raw?.products)
        ? raw.products
        : Array.isArray(raw?.produtos)
          ? raw.produtos
          : [];

    return products.map((product: any) => {
      if (!product?.id) return product;

      const imageUrl = `/api/product-image/${encodeURIComponent(String(product.id))}`;

      return {
        ...product,
        image: /^data:image\//i.test(String(product.image || ''))
          ? imageUrl
          : product.image,
        imagem: /^data:image\//i.test(String(product.imagem || ''))
          ? imageUrl
          : product.imagem,
      };
    });
  },
});

const displayProducts = computed(() => {
  if (!Array.isArray(data.value)) return [];

  return data.value
    .filter((product: any) => product?.id && product?.slug)
    .slice(0, 8);
});
</script>
